import { NgFor } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';

interface ColorOption {
  value: string;
  name: string;
}

@Component({
  selector: 'app-color-picker',
  imports: [MatMenuTrigger, MatMenu, NgFor],
  templateUrl: './color-picker.component.html',
  styleUrl: './color-picker.component.scss'
})
export class ColorPickerComponent {

  @Input() selectedColor: string = '#36A2EB';

  @Output() colorChange = new EventEmitter<string>();

public colorPalette: ColorOption[] = [
  { value: '#3378cc', name: 'Primary Blue' },   // Jouw PROD blauw
  { value: '#308527', name: 'Success Green' },  // Jouw DEV groen
  { value: '#a50a17', name: 'Alert Red' },      // Jouw QA rood
  { value: '#00a3cc', name: 'Cyan Sky' },       // Complementair aan blauw
  { value: '#f29100', name: 'Warning Gold' },   // Goede accentkleur voor alle omgevingen
  { value: '#7b1fa2', name: 'Deep Purple' },    // Contrast voor de blauw/groen tinten
  { value: '#546e7a', name: 'Blue Grey' },      // Neutrale zakelijke tint
  { value: '#263238', name: 'Deep Slate' },     // Bijna zwart voor teksten/iconen
  { value: '#ff5252', name: 'Soft Coral' },     // Lichte variant van de rode tint
  { value: '#00bfa5', name: 'Teal Bright' }     // Brug tussen groen en blauw
];

  selectColor(color: string): void {
    this.selectedColor = color;
    this.colorChange.emit(color);
  }
}

